import { useBackend } from "../../services";

export const useGetPasskeyAuthenticationOptions = () => {
  const { get } = useBackend();
  return async () => {
    return await get("passkeys/authentication");
  };
};
